uniform float time;
uniform float delta;
uniform vec3 mouse;
uniform float camDistance;
uniform float fadeIn;
uniform float mouseDamping;


void main() {

  vec2 cellSize = 1.0 / resolution.xy;

  // vec2 uv = gl_FragCoord.xy * cellSize;

  vec2 uv = gl_FragCoord.xy / resolution.xy;
  // vec2 uv = resolution.xy;

  vec4 tmpPos = texture2D(texturePosition, uv);

  // tmpPos.xyz = vec3(0.,1.,1.);
  vec3 pos = tmpPos.xyz;

  // float dist = distance(mouse, pos) * (1. / camDistance);
  float dist = distance(mouse, pos) * 0.01;

  float distInv = pow((clamp(dist * 10., 0., 1.) - 1.), 4.) * 3.;
  // distInv = distInv + (1.- fadeIn) * 10.;

  // float distInv = (1. / dist) * 0.001;
  // if(distInv > 0.5) {
  //   tmpPos.w = distInv;
  // }

  // tmpPos.w = 0. + (1. / dist);
  float damping = .008;
  if(distInv > tmpPos.w) {
    damping = .03;
  }
  tmpPos.w += (distInv - tmpPos.w) * damping;

  // vec3 target = pos + amplitude * curlNoise(vec3(f * pos.x, f * pos.y, f * pos.z));

  // vec3 target = pos + vec3(sin(time) * 0.001,cos(time) * 0.001,sin(time) * 0.001);

  gl_FragColor = vec4(pos,tmpPos.w);
  // gl_FragColor = tmpPos;
    // gl_FragColor = vec4(tmpPos, tmpPos.w);
  // gl_FragColor = texture2D(texturePosition, uv);
}